import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
import { badgeKindToMidasClassName } from '../Badge/Badge';
export const buttonSizeToMidasClassName = (size) => ({
    small: midas.buttonSmall,
    normal: undefined,
    large: midas.buttonLarge,
}[size]);
export const buttonTypeToMidasClassName = (type) => ({
    primary: midas.buttonPrimary,
    normal: midas.buttonNormal,
    link: midas.buttonLink,
}[type]);
const buttonKindToMidasClassName = (kind) => ({
    normal: undefined,
    danger: midas.danger,
    warning: midas.warning,
    success: midas.success,
    info: midas.info,
    style: midas.style,
}[kind]);
const Button = ({ children, id, disabled = false, loading = false, onClick, tabIndex, text, role, icon, invert = false, size = 'normal', type = 'normal', kind = 'normal', fullWidth = false, badge = false, badgeKind, badgeLabel, form = false, autoFocus = false, dataCy, }) => (React.createElement("button", { id: id, type: form ? 'submit' : 'button', disabled: disabled, role: role, 
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: autoFocus, tabIndex: tabIndex, style: invert
        ? {
            background: 'transparent',
            color: 'white',
            borderColor: type !== 'link' ? 'white' : undefined,
        }
        : undefined, className: classNames(midas.button, loading && midas.loading, type && buttonTypeToMidasClassName(type), kind && buttonKindToMidasClassName(kind), size && buttonSizeToMidasClassName(size), badge && midas.badge, fullWidth && midas.buttonBlock, badgeKind && badgeKindToMidasClassName(badgeKind)), "data-cy": dataCy, "data-badge": badgeLabel ? badgeLabel || '' : null, onClick: onClick },
    icon && (React.createElement("span", null,
        React.createElement("i", { className: classNames(midas.icon, midas[icon]) }),
        ' ')),
    text,
    children));
export default Button;
